import { get as _get, cloneDeep } from 'lodash'
import { DISPLAY_TYPE_OPTIONS } from './constant.js'

export function initSettingStore (interestData, data = {}) {
  const { resultData, interestSetting } = data
  if (!_get(interestData, 'length') || !resultData) {
    return []
  }
  const firstInterest = interestData[0]
  const store = {
    displayType: DISPLAY_TYPE_OPTIONS.some(o => o.key === firstInterest.displayType) ? firstInterest.displayType : DISPLAY_TYPE_OPTIONS[1].key,
    activeProductId: firstInterest.productId,
    productFormList: []
  }
  const list = interestData.map((ele) => {
    const { productId } = ele
    const _prodOrderList = _get(resultData, 'productGroupList[0].prodOrderList') || []
    const _product = _prodOrderList.find(p => p.key === productId)
    const _mulInsOrderList = _get(_product, 'mulInsOrderList') || []
    const resultAddAndTakeIns = _mulInsOrderList.find(ins => ins.account && ins.accountData && ins.accountData.accountPart)
    const resultReduceBaofIns = _mulInsOrderList.find(ins => ins.reduceBaof)

    const bonus = _get(ele, 'bonus.value') || ''
    const accRate = _get(ele, 'accRate')||null
    const takeType = _get(ele, 'takeType.value') || null
    const bonusTake = _get(ele, 'bonusTake.value') || null
    const pensionTake = _get(ele, 'pensionTake.value') || null
    const rate = _get(ele, 'rate.value') || null
    const rateIndex = _get(ele, 'rate.opts') ? ele.rate.opts.findIndex(o => o.value === rate) : null
    const addAndTakeData = _get(ele, 'accountData') || null
    // 减保领取数据是接口返回数据中的 addAndTakeData 字段
    const drawData = _get(ele, 'addAndTakeData') || null
    const duplicateDrawData = _get(ele, 'duplicateAddAndTakeData') || null
    const drawInsuranceId = resultReduceBaofIns ? resultReduceBaofIns.key : null
    const accountInsuranceId = resultAddAndTakeIns ? resultAddAndTakeIns.key : null
    const displayAge = ele.displayAge ? ele.displayAge : null
    const addAndTakeFlag = (_get(addAndTakeData, 'addAndTakeData') || []).some(ele => ele.adjustData && ele.adjustData.length)
    const drawFlag = (drawData || []).some(ele => ele.adjustData && ele.adjustData.length) || (duplicateDrawData || []).some(ele => ele.adjustData && ele.adjustData.length)
    const singleCalType = _get(ele, 'singleCalType') || 1
    return {
      productId: ele.productId,
      drawInsuranceId,
      accountInsuranceId,
      customRate: null,
      addAndTakeData,
      drawData,
      duplicateDrawData,
      formValues: {
        accRate,
        bonus,
        takeType,
        bonusTake,
        pensionTake,
        rate,
        rateIndex,
        displayFields: [],
        displayAge,
        drawFlag,
        addAndTakeFlag,
        isShowFieldPopup: false,
        isShowRatePopup: false,
        isShowBonusPopup: false,
        maxBonusCustomRate: 100,
        hideFieldsForClient: [],
        dragValue: 0,
        singleCalType
      }
    }
  })

  // app端，保留用户上一次的配置数据。计划书配置变化，可能导致某些选项丢失，需要处理
  if (interestSetting) {
    const { activeProductId, displayType, productFormList } = interestSetting
    if (activeProductId && interestData.some(e => e.productId === activeProductId)) {
      store.activeProductId = activeProductId
    }
    if (DISPLAY_TYPE_OPTIONS.some(o => o.key === displayType)) {
      store.displayType = displayType
    }
    const _productFormList = productFormList || []
    _productFormList.forEach(maybeLegacySettingForm => {
      const prod = transformLegacySettings(maybeLegacySettingForm)
      const interestProduct = interestData.find(e => e.productId === maybeLegacySettingForm.productId)
      const temp = list.find(e => e.productId === prod.productId)
      if (temp) {
        for (const k in prod) {
          if (['addAndTakeData', 'drawData', 'duplicateDrawData'].includes(k)) {
            continue
          }
          if (['formValues'].includes(k)) {
            for (const vk in prod.formValues) {
              const _keys = ['bonus', 'takeType', 'bonusTake', 'pensionTake', 'rate']
              if (_keys.includes(vk)) {
                const _options = _get(interestProduct, `${vk}.opts`) || []
                if (vk === 'rate' && typeof prod.formValues[vk] === 'string') {
                  prod.formValues[vk] = Number(prod.formValues[vk])
                }
                if (_options.some(o => !o.hiddenFlag && o.value === prod.formValues[vk])) {
                  temp.formValues[vk] = prod.formValues[vk]
                }
              } else {
                temp.formValues[vk] = prod.formValues[vk]
              }
            }
            if (!prod.formValues.displayAge || prod.formValues.displayAge === -1) {
              temp.formValues.displayAge = null
            }
            continue
          }
          // customRate 是 Number 类型。服务端的数据库在存储时字符串化，读数据时，类型可能未转为 Number。
          // 请求数据分两种情况：从正常数据（mongodb）读取，类型为 String；从缓存（redis）读取，类型还是 Number。
          // 服务端已做优化，前端兼容老数据
          if (k === 'customRate' && Number(prod[k])) {
            prod[k] = Number(prod[k])
          }
          temp[k] = prod[k]
        }
      }
    })
  }
  list.forEach(item=>{
    if(item.formValues.accRate){
      item.formValues.accRate=_get(item.formValues, 'accRate')>0.05?Number((_get(item.formValues, 'accRate')/100).toFixed(4)):_get(item.formValues, 'accRate')||null
    }
  })
  //兼容新老数据：例子：接口拿到数据3.2但是传入到计算属性需要是0.032而不是3.2，所以需要做个判断
  store.productFormList = list
  return store
}

function transformLegacySettings (legacySettingForm) {
  const result = cloneDeep(legacySettingForm)

  ;['insuranceId', 'drawInsuranceId', 'accountInsuranceId'].forEach(key => {
    if (result.hasOwnProperty(key)) {
      delete result[key]
    }
  })
  if (result.formValues) {
    const {beforeFlag} = result.formValues
    if (beforeFlag != null) {
      const { addAndTakeData } = result
      const hasAddAndTakeData = addAndTakeData && addAndTakeData.some(ele => ele.adjustData && ele.adjustData.length)
      const beforeFlagMapKey = hasAddAndTakeData ? 'addAndTakeFlag' : 'drawFlag'
      result.formValues[beforeFlagMapKey] = !beforeFlag
      delete result.formValues.beforeFlag
    }
  }
  return result
}

export function getBaofMultipleTag (data, curProductFormData= {}) {
  if (!(data && data.length)) {
    return data
  }
  const drawFlag = !!_get(curProductFormData, 'formValues.drawFlag')
  let multipleData = []
  const keys = ['cash_value']
  if (!drawFlag) {
    keys.push('total_value');
  }
  const baofKeys = ['__baof_divisor', 'baofei_sum', 'baof_sum']
  keys.forEach(key => {
    data.forEach(ele => {
      let baseBaof = null
      for (const k of baofKeys) {
        if (ele[k] !== undefined) {
          baseBaof = ele[k]
          break
        }
      }
      if (baseBaof === null || baseBaof <= 0) {
        return
      }
      const multiple = Math.trunc(ele[key] / baseBaof)
      if (multiple > 0 && !multipleData.find(m => m.multiple === multiple)) {
        multipleData.push({
          value: ele[key],
          multiple
        })
      }
    })
    data.forEach(ele => {
      const multiple = multipleData.find(m => m.value === ele[key])
      if (multiple) {
        ele[`__${key}__multiple_tag`] = `×${multiple.multiple}`
        multipleData = multipleData.filter(m => m.multiple !== multiple.multiple)
      }
    })
  })
  return data
}


export function getInterestTag (data, interestDetailData= {}) {
  if (!(data && data.length)) {
    return data
  }
  const interestMap = {
    0: {
      name: '增',
      key: 'interest_ze'
    },
    1: {
      name: '领',
      key: 'interest_lq'
    },
    2: {
      name: '累',
      key: 'interest_lj'
    }
  }
  const dataList = interestDetailData.dataList || []
  const isBonusAdd = dataList.find(item => item.key === 'isBonusAdd')
  const isAnnuityAdd = dataList.find(item => item.key === 'isAnnuityAdd')

  // 提前提取 valueList，避免在循环中重复访问
  const bonusAddValues = isBonusAdd ? (isBonusAdd.values || []) : []
  const annuityAddValues = isAnnuityAdd ? (isAnnuityAdd.values || []) : []

  // 辅助函数：设置标签
  const setTag = (record, fieldKey, tagValue, index) => {
    if (tagValue !== undefined && tagValue !== null && interestMap[tagValue]) {
      const tagInfo = interestMap[tagValue]
      record[`__${fieldKey}__${tagInfo.key}_tag`] = tagInfo.name
    }
  }

  data.forEach((record, index) => {
    if (record.annuity_year && annuityAddValues.length > index) {
      setTag(record, 'annuity_year', annuityAddValues[index], index)
    }
    if (record.bonus_year && bonusAddValues.length > index) {
      setTag(record, 'bonus_year', bonusAddValues[index], index)
    }
  })
  return data
}
